export default __webpack_public_path__ + "static/media/service-img3.24011d97.jpg";